import React from "react";
import { useLocation } from "wouter";
import Button, { ButtonTypes } from "../../components/Button";
import {
  FullPageWrapper,
  ContentContainer,
  NotFoundNumber,
  NotFoundTitle,
  NotFoundDescription,
  ButtonGroup,
  HelpText,
} from "./styles";

export const NotFound: React.FC = () => {
  const [, navigate] = useLocation();

  return (
    <FullPageWrapper>
      <ContentContainer>
        <NotFoundNumber>404</NotFoundNumber>
        <NotFoundTitle>Page Not Found</NotFoundTitle>
        <NotFoundDescription>
          The page you're looking for doesn't exist or has been moved.
        </NotFoundDescription>
        <ButtonGroup>
          <Button
            type={ButtonTypes.primary}
            size="large"
            onClick={() => navigate("/")}
          >
            Go to Dashboard
          </Button>
          <Button
            type={ButtonTypes.revert}
            size="large"
            onClick={() => globalThis.window.history.back()}
          >
            Go Back
          </Button>
        </ButtonGroup>
        <HelpText>
          If you believe this is an error, please contact support.
        </HelpText>
      </ContentContainer>
    </FullPageWrapper>
  );
};
